import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';
import { dayInMilliseconds } from 'utils/utils';
import Loading from 'components/Loading/Loading';

import './SearchUnitCustomControlCalendarDay.scss';

export default class SearchUnitCustomControlCalendarDay extends Component {
  static propTypes = {
    date: PropTypes.object,
    appState: PropTypes.object.isRequired,
    handleDayClick: PropTypes.func.isRequired,
  };

  shouldComponentUpdate = shouldPureComponentUpdate;

  get highlight() {
    const { date } = this.props;
    let highlights = '';

    if (date.highlight) {
      highlights += ' search-unit-custom-control-calendar-day--selected';
    }

    if (date.unavailable) {
      highlights += ' search-unit-custom-control-calendar-day--unavailable';
    } else {
      highlights += ' search-unit-custom-control-calendar-day--available';
    }

    return `search-unit-custom-control-calendar-day${highlights}`;
  }

  handleDateClick = (e) => {
    const { handleDayClick } = this.props;
    e.preventDefault();
    const theDate = this.props.date;
    const calDate = Date.UTC(theDate.year, theDate.month, theDate.day) / dayInMilliseconds;
    handleDayClick(calDate);
  };

  render() {
    const { date } = this.props;
    let listItem;

    if (date) {
      const dateContents = (
        <div>
          <time
            dateTime={`${date.year}-${date.month + 1}-${date.day}`}
            className="search-unit-custom-control-calendar-day__number"
          >
            {date.day}
          </time>
        </div>
      );

      listItem = (
        <td className={this.highlight}>
          {
            date.highlight === 'selected' || date.unavailable ? (
              <div className="search-unit-custom-control-calendar-day__link">
                { dateContents }
              </div>
            ) : (
              <a
                href=""
                className="search-unit-custom-control-calendar-day__link"
                onClick={this.handleDateClick}
              >
                { dateContents }
              </a>
            )
          }
          {
            date.highlight === 'depart' &&
            <Loading loadingState={this.props.appState.get('loadingState')} isSmall />
          }
        </td>
      );
    } else {
      listItem = (
        <td className="search-unit-custom-control-calendar-day search-unit-custom-control-calendar-day--not-this-month">
          <time className="search-unit-custom-control-calendar-day__number">--</time>
        </td>
      );
    }

    return listItem;
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/SearchUnitCustomControlCalendar/SearchUnitCustomControlCalendarDay.jsx
 **/